export const getCurrentEduBudgetPeriod = () => {
  const currentDate = new Date();
  return `01.01.${currentDate.getFullYear()} - 30.11.${currentDate.getFullYear()}`;
};
